<div>
  <tool-header
    class="tool-header"
    headerTitle="Financial Aid Tool"
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Financial Aid Tool.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Financial Aid<i class="fa-solid fa-arrow-right"></i> Financial Aid
          Tool
        </h1>

        <h2 class="h2-header">Financial Aid Tool Page</h2>

        <h3 class="h3-second-header">Financial Aid Form Submission</h3>

        <ol class="ordered-list">
          <li>
            Select the year or multiple years (All Years, 2017-2018, 2018-2019,
            2019-2020, 2020-2021, 2021-2022)
          </li>
          <li>
            Select the student type or multiple student types (All student
            group, FTIC, Transfer, Continuing)
          </li>
          <li>
            Select the fund source or multiple fund sources (All fund source,
            Institutional, Federal, State)
          </li>
          <li>
            Select the fund type or multiple fund types (Example: FGMF, FSGF,
            FSGT, FSAG, FGMG [If previous for field was State])
          </li>
          <li>
            * Lastly, click on the ‘Submit’ button to generate results for
            Financial Aid.
          </li>
        </ol>
      </div>

      <div class="left-align-div">
        <p class="additional-comments">
          <b
            >* = Submit button will only be visible if all the fields are
            complete.</b
          >
        </p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageFinancialAidToolFig31']"
            alt=""
          />
          <p class="picture-caption">Figure 31: Financial Aid Tool Page</p>
        </div>
      </div>

      <div class="left-align-div">
        <p class=""></p>
        <div>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageFinancialAidToolFig31a']"
            alt=""
          />
          <p class="picture-caption">
            Figure 31a: Financial Aid Form Submission Example
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will see 3 graphs like the screenshot
            (Figure 32) below. That shows you the financial aid awarded for the
            past years.
          </li>
          <li>
            You can also click on the colored boxes that’s above the graphs to
            remove any line on the graphs based on the color.
          </li>
          <div>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageFinancialAidToolFig32']"
              alt=""
            />
            <p class="picture-caption">
              Figure 32: Example Graph for Results of Financial Aid Tool
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>
</div>
